import script from "./GastronomyMenuSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./GastronomyMenuSection.vue?vue&type=script&setup=true&lang=ts"

import "./GastronomyMenuSection.vue?vue&type=style&index=0&id=ac5eeb4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac5eeb4c"]])

export default __exports__